import { Map } from 'immutable'
import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'
import { detectDateFormat } from './shared.utils'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'array',
})
export class ArrayPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value ? value.toJS() : []
  }
}

@Pipe({
  name: 'integer',
})
export class IntegerPipe implements PipeTransform {
  transform(value: any): any {
    return value ? parseInt(value) : undefined
  }
}

@Pipe({
  name: 'countdown',
})
export class CountdownPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  singularize(value: number, string: string) {
    if (value > 1 || value === 0) {
      return `${string}s`
    }
    return string
  }

  transform(value: any, ...args: any[]): any {
    const format = args[0]

    if (Map.isMap(value)) {
      const hours = value.get('hours') as number
      const minutes = value.get('minutes') as number
      const seconds = value.get('seconds') as number

      return `${hours} ${this.translateService.instant(
        this.singularize(hours, 'hour').toUpperCase(),
      )} ${minutes} ${this.translateService.instant(
        this.singularize(minutes, 'minute').toUpperCase(),
      )} ${seconds} ${this.translateService.instant(
        this.singularize(seconds, 'second').toUpperCase(),
      )}`
    } else if (!isNaN(value)) {
      const min = Math.floor((value / 1000 / 60) << 0)
      const sec = Math.floor((value / 1000) % 60)

      if (format === 'mm:ss') {
        return `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`
      }
    }
    return ''
  }
}

@Pipe({
  name: 'listToString',
})
export class ListToStringPipe implements PipeTransform {
  transform(value: any, key: string): any {
    return value
      ? value.map((item: Map<string, any>) => item.get(key)).join(', ')
      : ''
  }
}

@Pipe({
  name: 'keyToText',
})
export class KeyToTextPipe implements PipeTransform {
  transform(value: any): any {
    return value && value.replace('_', ' ').toLowerCase()
  }
}

@Pipe({
  name: 'mapToString',
})
export class MapToStringPipe implements PipeTransform {
  transform(value: any): any {
    const arrayOfStrings: string[] = []

    value.forEach((val, key) => {
      arrayOfStrings.push(`${key}: ${val}`)
    })

    return value ? arrayOfStrings.join(', ') : ''
  }
}

@Pipe({
  name: 'formatDate',
})
export class FormatDate implements PipeTransform {
  transform(value: any, format: string = null): any {
    const detectedFormat = detectDateFormat(value).format

    if (detectedFormat) {
      if (detectedFormat.toLocaleLowerCase() === format?.toLocaleLowerCase()) {
        return value
      }
    }

    const actualFormat = value.includes(' ') ? 'MM.DD.yyyy HH:mm' : 'MM.DD.yyyy'

    return (
      value &&
      moment(value, 'DD-MM-yyyy HH:mm:ss').format(format ?? actualFormat)
    )
  }
}
